/**
 * Extend the String prototype with some useful helper functions
 */
define('core/polyfills/String',[
	'global!String',
	'global!String.prototype',
], function(
	String,
	StringPrototype
) {
	'use strict';


	// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	if (! StringPrototype.trim) {
		// Make sure we trim BOM and NBSP
		var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
		StringPrototype.trim = function() {
			return this.replace(rtrim, '');
		};
	}


	// http://stackoverflow.com/a/3291856
	StringPrototype.capitalize = function() {
		return this.charAt(0).toUpperCase() + this.slice(1);
	};



	/**
	 * This function tries to converts a string, which contains css times (400ms, 0.25s), to milliseconds as an int.
	 * If there is no unit specified, numbers will be interpreted as milliseconds.
	 * If the value is not a correct number, this function will return 0
	 *
	 * @param {bool} addUnit  if this is true, this function will return a string instead of an int with the unit "ms"
	 * @return {int|string}   representative time as milliseconds
	 *
	 * @see  http://www.w3.org/TR/css3-values/#time
	 */
	StringPrototype.convertCssTime = function(addUnit) {

		var unitSplitRegex = /([\d\.]+)(m?s)?/i,
			value = this.trim(),
			matches = unitSplitRegex.exec(value)
		;

		// if the value is a malformed int reset the array
		if (matches === null) {
			matches = [value, 0];
		}

		// get the actual value and parse it
		value = parseFloat(matches[1]);

		// multiply the value times 1000 if the unit is in seconds
		if (matches[2] === 's') {
			value = value * 1000;
		}

		// if the parameter addUnit is set convert the value to string and append the "ms" unit
		if (addUnit) {
			value = value + 'ms';
		}
		return value;
	};


	/**
	 * Does the same as a simple form of python "".format
	 * that will not work for anything else than number or string.
	 * Array form :
	 *      "I have {} replacements to {}".format("two", "make")
	 *      "I have {} replacements to {}".format(["two", "make"])
	 *      "I have {0} replacements to {1}".format(["two", "make"])
	 * Dict form :
	 *      "Hello {name} !".format({name: "Bob"});
	 *      "I am {age} years old".format({age: 12});
	 *      "Pi is {pi} ! ".format({"pi": Math.PI});
	 * No error is outputed in case of malformed input. It just isn't replaced.
	 *
	 * @TODO: Find the author and credit him
	 * @TOOD: allow nested object properties like {customer.name}
	 **/
	StringPrototype.format = function (obj) {
		var source = (typeof obj === 'object') ? obj : arguments,
			i = 0
		;
		return this.replace(/{([^{}]*)}/g, function (a, b) {
			if (b === ''){
				b = i ++;
			}
			var r = source[b];

			return (typeof r === 'string' || typeof r === 'number') ? r : a;
		});
	};

});

